<template>
  <v-container fluid>
    <fin-user-subscription/>
  </v-container>
</template>

<script>
import FinUserSubscription from "@/components/pages/profile/subscription/Subscription"

export default {
  name: "DemoTool",
  components: {FinUserSubscription}
}
</script>

<style scoped>

</style>
